import { lazy } from "react";
import { Redirect } from "react-router-dom";

const AppRoutes = [
  {
    path: "/ape",
    appLayout: false,
    className: "chat-application",
    component: lazy(() => import("../../views/apps/ape")),
  },
  {
    path: "/trending",
    appLayout: false,
    className: "chat-application",
    component: lazy(() => import("../../views/apps/trending")),
  },
  {
    path: "/tokens/:address",
    exact: false,
    appLayout: true,
    className: "email-application",
    component: lazy(() => import("../../views/apps/chart")),
  },
  {
    path: "/tokens",
    exact: true,
    appLayout: true,
    component: () => <Redirect to="/tokens/0xa397233a0c08052df7569b089864afeb7dc7f8b0" />,
  },
  {
    path: "/contracts/:address",
    exact: false,
    appLayout: true,
    className: "email-application",
    component: lazy(() => import("../../views/apps/analysis")),
  },
  {
    path: "/contracts",
    exact: true,
    appLayout: true,
    component: () => <Redirect to="/contracts/0xa397233a0c08052df7569b089864afeb7dc7f8b0" />,
  },
  // {
  //   path: "/apps/email/:folder",
  //   exact: true,
  //   appLayout: true,
  //   className: "email-application",
  //   component: lazy(() => import("../../views/apps/email")),
  //   meta: {
  //     navLink: "/apps/email",
  //   },
  // },
  // {
  //   path: "/apps/email/label/:label",
  //   exact: true,
  //   appLayout: true,
  //   className: "email-application",
  //   component: lazy(() => import("../../views/apps/email")),
  //   meta: {
  //     navLink: "/apps/email",
  //   },
  // },
  // {
  //   path: "/apps/email/:filter",
  //   component: lazy(() => import("../../views/apps/email")),
  //   meta: {
  //     navLink: "/apps/email",
  //   },
  // },
  // {
  //   path: "/apps/chat",
  //   appLayout: true,
  //   className: "chat-application",
  //   component: lazy(() => import("../../views/apps/chat")),
  // },
  // {
  //   path: "/apps/todo",
  //   exact: true,
  //   appLayout: true,
  //   className: "todo-application",
  //   component: lazy(() => import("../../views/apps/todo")),
  // },
  // {
  //   path: "/apps/todo/:filter",
  //   appLayout: true,
  //   exact: true,
  //   className: "todo-application",
  //   component: lazy(() => import("../../views/apps/todo")),
  //   meta: {
  //     navLink: "/apps/todo",
  //   },
  // },
  // {
  //   path: "/apps/todo/tag/:tag",
  //   appLayout: true,
  //   className: "todo-application",
  //   component: lazy(() => import("../../views/apps/todo")),
  //   meta: {
  //     navLink: "/apps/todo",
  //   },
  // },
  // {
  //   path: "/apps/calendar",
  //   component: lazy(() => import("../../views/apps/calendar")),
  // },
  // {
  //   path: "/apps/invoice/list",
  //   component: lazy(() => import("../../views/apps/invoice/list")),
  // },
  // {
  //   path: "/apps/invoice/preview/:id",
  //   component: lazy(() => import("../../views/apps/invoice/preview")),
  //   meta: {
  //     navLink: "/apps/invoice/preview",
  //   },
  // },
  // {
  //   path: "/apps/invoice/preview",
  //   exact: true,
  //   component: () => <Redirect to="/apps/invoice/preview/4987" />,
  // },
  // {
  //   path: "/apps/invoice/edit/:id",
  //   component: lazy(() => import("../../views/apps/invoice/edit")),
  //   meta: {
  //     navLink: "/apps/invoice/edit",
  //   },
  // },
  // {
  //   path: "/apps/invoice/edit",
  //   exact: true,
  //   component: () => <Redirect to="/apps/invoice/edit/4987" />,
  // },
  // {
  //   path: "/apps/invoice/add",
  //   component: lazy(() => import("../../views/apps/invoice/add")),
  // },
  // {
  //   path: "/apps/invoice/print",
  //   layout: "BlankLayout",
  //   component: lazy(() => import("../../views/apps/invoice/print")),
  // },
  // {
  //   path: "/apps/ecommerce/shop",
  //   className: "ecommerce-application",
  //   component: lazy(() => import("../../views/apps/ecommerce/shop")),
  // },
  // {
  //   path: "/apps/ecommerce/wishlist",
  //   className: "ecommerce-application",
  //   component: lazy(() => import("../../views/apps/ecommerce/wishlist")),
  // },
  // {
  //   path: "/apps/ecommerce/product-detail",
  //   exact: true,
  //   className: "ecommerce-application",
  //   component: () => <Redirect to="/apps/ecommerce/product-detail/apple-i-phone-11-64-gb-black-26" />,
  // },
  // {
  //   path: "/apps/ecommerce/product-detail/:product",
  //   exact: true,
  //   className: "ecommerce-application",
  //   component: lazy(() => import("../../views/apps/ecommerce/detail")),
  //   meta: {
  //     navLink: "/apps/ecommerce/product-detail",
  //   },
  // },
  // {
  //   path: "/apps/ecommerce/checkout",
  //   className: "ecommerce-application",
  //   component: lazy(() => import("../../views/apps/ecommerce/checkout")),
  // },
  // {
  //   path: "/apps/user/list",
  //   component: lazy(() => import("../../views/apps/user/list")),
  // },
  // {
  //   path: "/apps/user/edit",
  //   exact: true,
  //   component: () => <Redirect to="/apps/user/edit/1" />,
  // },
  // {
  //   path: "/apps/user/edit/:id",
  //   component: lazy(() => import("../../views/apps/user/edit")),
  //   meta: {
  //     navLink: "/apps/user/edit",
  //   },
  // },
  // {
  //   path: "/apps/user/view",
  //   exact: true,
  //   component: () => <Redirect to="/apps/user/view/1" />,
  // },
  // {
  //   path: "/apps/user/view/:id",
  //   component: lazy(() => import("../../views/apps/user/view")),
  //   meta: {
  //     navLink: "/apps/user/view",
  //   },
  // },
];

export default AppRoutes;
